import { ApolloError } from '@apollo/client';

import { useApiGatewayQuery } from '~hooks';
import { GET_TIMESLOTS } from '~queries';
import { GetTimeslotsQuery, QueryTimeslotsArgs, Timeslot } from '~types/appsync.types';

const EMPTY: Timeslot[] = [];

const useTimeslots = (
  productSlug?: string,
  dateFrom?: string,
  dateTo?: string,
): [Timeslot[], boolean, ApolloError | undefined] => {
  const { loading, error, data } = useApiGatewayQuery<GetTimeslotsQuery, QueryTimeslotsArgs>(
    GET_TIMESLOTS,
    {
      skip: !productSlug || !dateFrom || !dateTo,
      variables: {
        dateFrom: dateFrom!,
        dateTo: dateTo!,
        productSlug: productSlug!,
      },
    },
  );

  return [data?.timeslots ?? EMPTY, loading, error];
};

export default useTimeslots;
